import axios from 'axios'

const accessToken = localStorage.getItem('accessToken');
const base = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer ' + accessToken
  }
});

const Api = {
  getAgenda(agendaId, agendaData = {}) {
    return base.get(agendaId, { params: agendaData});
  },
  getAvailableHealthPlans(agendaId, appointmentData = {}) {
    return base.get('health-plans/' + agendaId, { params: appointmentData});
  },
  makeAppointment(agendaId, appointmentData) {
    return base.post(agendaId, appointmentData);
  },
  getTelehealthAppointment(id, appointmentData = {}) {
    return base.get('telehealth-appointment/' + id, { params: appointmentData});
  },
  checkTelehealthAttendance(id, appointmentData = {}) {
    return base.get('telehealth-appointment/' + id + '/check', { params: appointmentData});
  }
};

export default Api
